import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../Hook";
import { userApi } from "../../features/users/usersApi";
import { cardApi } from "../../features/card/cardApi";
import { planApi } from "../../features/creditPlan/planApi";
import { crmApi } from "../../features/crm/crmApi";
import { emailTemplateApi } from "../../features/emailTemplate/emailTemplateApi";
import { occationApi } from "../../features/occation/occationApi";
import { orderApi } from "../../features/order/orderApi";

const Logout = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    dispatch(userApi.util.resetApiState());
    dispatch(occationApi.util.resetApiState());
    dispatch(emailTemplateApi.util.resetApiState());
    dispatch(userApi.util.resetApiState());
    dispatch(orderApi.util.resetApiState());
    dispatch(crmApi.util.resetApiState());
    dispatch(cardApi.util.resetApiState());
    dispatch(planApi.util.resetApiState());
    navigate("/login");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>Logging out</div>;
};

export default Logout;
